<template>

  <v-container fluid class="delivery-order-supporting-docs-viewer">

    <v-row v-if="isDataLoading">
      <v-col cols="12" class="d-flex align-center justify-center">
        <v-progress-circular indeterminate :size="40" class="mt-10" color="primary" />
      </v-col>
    </v-row>

    <template v-else>

      <!-- Scrollable supporting docs -->
      <template v-if="sortedDocs && sortedDocs.length > 0">
        <v-row class="mb-2">
          <v-col class="d-flex align-center justify-center">
            <span class="total-docs-label mr-2">Total docs:</span><span class="total-docs-count">{{ docCount }}</span>
          </v-col>
        </v-row>
        <v-row class="mb-5 pr-xs-3 pr-sm-7 pr-md-8" v-for="(docInfo, index) in sortedDocs" :key="index">
          <v-col cols="12">
            <div class="mb-4 file-label">{{ docInfo.label }}</div>
            <div class="d-flex align-center justify-center">
              <!-- Images -->
              <img
                v-if="docInfo.file_type === 'image/png'"
                class="file-frame frame-img"
                :src="docInfo.url"
                style="width:100%;max-height:500px;object-fit:contain;"
                alt="" />

              <!-- PDFs on iPadOS: use iframe for better multi-page support -->
              <iframe
                v-else-if="docInfo.file_type === 'application/pdf' && isIPadOS"
                class="file-frame frame-pdf-ipad"
                :src="generateDocViewerUrl(docInfo.url)"
                width="100%"
                height="500"
                style="border:0;" />

              <!-- PDFs elsewhere: keep embed -->
              <embed
                v-else-if="docInfo.file_type === 'application/pdf'"
                class="file-frame frame-pdf"
                :src="docInfo.url"
                width="100%"
                height="500"
                type="application/pdf" />

              <!-- Fallback for other file types -->
              <embed
                v-else
                class="file-frame frame-other"
                :src="docInfo.url"
                width="100%"
                height="500" />
            </div>
          </v-col>
        </v-row>
      </template>

      <!-- (no docs) -->
      <v-row class="mt-6" v-else>
        <v-col class="d-flex align-center justify-center">
          <span class="no-docs-text">(No supporting docs)</span>
        </v-col>
      </v-row>

    </template>

  </v-container>

</template>

<script>
export default {
  name: 'DeliveryOrderSupportingDocsViewer',

  props: {
    order: {
      type: Object,
      required: true
    }
  },

  data () {
    return {
      isDataLoading: false,
      orderIdForAssets: null,
      docs: []
    }
  },

  computed: {
    docCount () {
      return this.docs.length
    },
    sortedDocs () {
      return this.$root.utils.sortBy(this.docs, ['order'])
    },
    // isIOs () {
    //   const isIPhone = window.navigator.platform.toLowerCase() === 'iphone'
    //   const isIPad = window.navigator.platform.toLowerCase() === 'ipad' ||
    //     (window.navigator.platform.toLowerCase() === 'macintel' && window.navigator.standalone !== undefined)

    //   return isIPhone || isIPad
    // },
    isIPadOS () {
      const userAgent = navigator.userAgent || ''
      const isIOSDevice = /iPad|iPhone|iPod/.test(userAgent)
      const isIPadViaDesktopMode = navigator.platform === 'MacIntel' && navigator.maxTouchPoints > 1
      return isIOSDevice || isIPadViaDesktopMode
    }
  },

  async beforeMount () {
    // Load order ID for assets
    this.orderIdForAssets = (this.order.root_order_id) ? this.order.root_order_id : this.order.id

    // Load supporting docs for display
    this.loadSupportingDocs()
  },

  methods: {
    // Direct to Google doc viewer
    generateDocViewerUrl (url) {
      if (!url) return false
      return `https://drive.google.com/viewerng/viewer?embedded=true&url=${encodeURIComponent(url)}`
    },

    async loadSupportingDocs () {
      const docInfo = this.order.supporting_docs || {}
      const assets = Object.entries(docInfo)

      this.isDataLoading = true

      for (const [key, data] of assets) {
        const url = await this.$root.fetchOrderAsset(this.orderIdForAssets, key)
        this.docs.push({ ...data, url })
      }

      this.isDataLoading = false
    }
  }
}
</script>

<style scoped>
  .total-docs-label {
    color: #727272;
    font-size: 1.1rem;
  }

  .total-docs-count {
    font-size: 1.2rem;
    font-weight: 500;
  }

  .no-docs-text {
    color: #727272;
    font-size: 1.2rem;
  }

  .file-frame {
    border:3px solid #727272;
    border-radius: 4px;
  }

  .file-label {
    font-size: 1.1rem;
  }

  /* .frame-img {
    border: 3px solid #cc0000 !important;
  } */

  /* .frame-pdf-ipad {
    border: 3px solid #00cc00 !important;
  } */

  /* .frame-pdf {
    border: 3px solid #0000cc !important;
  } */

  /* .frame-other {
    border: 3px solid #FFFFFF !important;
  } */
</style>
